import classNames from "classnames";
import React from "react";

import styles from "./ContentsBox.module.scss";

interface Props {
  boxSize?: "mediumBox" | "smallBox";
}

class ContentsBox extends React.PureComponent<Props> {
  public render() {
    const { boxSize = "smallBox" } = this.props;
    const containerClass = classNames(styles[boxSize]);
    return <div className={containerClass}>{this.props.children}</div>;
  }
}

export default ContentsBox;
